import useQueryData from "hooks/useQueryData";
import { GET_PUBLIC_MISSION_ROLE_APPLICANT } from "graphql/queries";

export default function usePublicMissionRoleApplicant({ id, skip }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_PUBLIC_MISSION_ROLE_APPLICANT,
    skip: !id || skip,
    variables: { id },
  });

  return {
    loading,
    data: data?.publicMissionRoleApplicant,
    error,
  };
}
